
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gEaaFL88_9KPwa7QwIJ6nE5kUf6uly3bTZuaekGJii3UMeta } from "/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexdhSOaN79RUJYA5mtU3oOg5yWsLGjJmmD9lZp4EE_N3UMeta } from "/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchlN_45kMhrmeG4id8NfIdbgzxgBQvUY8s97Ss2jFIEwUnsMeta } from "/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexmOkVykeYDHVFYF7WSaxb4AhTGZdM97MWOk7P_xTNFdMMeta } from "/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_931g9PgyKPSnGbRwDtw6TkzLyLy_45nE5RZS2k4OQgdWSb0Meta } from "/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index1aYg6jNwWi_bWBIzgpj_pElmKK6mnXg5jDDDD1wDSt4Meta } from "/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93Jzs8IQfZ4HJCsDDATKUkVGyypw50FJ4Q9W6W1r_sdbAMeta } from "/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index9xN9aq35f5IZ4dg1ISIOoJDFA9qBzNgST3RO8sehLjwMeta } from "/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_935ZZUO6lO6INx3t_45Mlgl05dwJM4vXWGXrPj0eYCoxTZAMeta } from "/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexu1m7EqU2j5S38sgtsOiiBcv5yrHXsNMG_4Clxz2yGf4Meta } from "/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexcP8qr7e0EzJ3NpCONVo679_45lnhXSbH4gaOhPB56rYioMeta } from "/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index1aYg6jNwWi_bWBIzgpj_pElmKK6mnXg5jDDDD1wDSt4Meta || {},
    component: () => import("/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index9xN9aq35f5IZ4dg1ISIOoJDFA9qBzNgST3RO8sehLjwMeta || {},
    component: () => import("/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexu1m7EqU2j5S38sgtsOiiBcv5yrHXsNMG_4Clxz2yGf4Meta || {},
    component: () => import("/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexcP8qr7e0EzJ3NpCONVo679_45lnhXSbH4gaOhPB56rYioMeta || {},
    component: () => import("/codebuild/output/src697285086/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]